export default __webpack_public_path__ + "images/d5a17a2bff2a1556f6ff9e438f6c1f53.png";